import {
  PSIG_TO_INHG_FACTOR,
  SUPPORTED_UNITS,
} from '@/helpers/unit-formatter/unit-formatter.constants';
import { UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import { fpMultiply, toNumber } from '@/helpers/unit-formatter/unit-formatter.utils';

export const transformPsi = (unitValue: UnitValue, newUnits?: string): UnitValue => {
  const value = toNumber(unitValue.value);
  if (value == null || value == undefined) return unitValue;

  switch (newUnits?.toLowerCase()) {
    case SUPPORTED_UNITS.INHG:
      return {
        value: -1 * fpMultiply(value, PSIG_TO_INHG_FACTOR),
        units: newUnits,
      };
    case SUPPORTED_UNITS.PSI:
    case SUPPORTED_UNITS.PSIA:
    case SUPPORTED_UNITS.PSIG:
      return {
        value: value,
        units: newUnits,
      };
    default:
      return unitValue;
  }
};
